export const isToggledSelector = (state, id) => state.ui.toggle[id];
